import React from 'react';
import { Icon, Main, Table, First, FileIconDiv, ResponsiveDiv, DocumentTitle, DocCreated } from './styles';
import { calculateDay, extensionName, formatDateWithTime } from '../../helpers/common';
import FileSVGIcon from '../../assets/images/svg/filesIconSvg';
import {
  FILE_EXTENSIONS,
  FILE_TYPES,
  FILES_MENU_OPTIONS,
  ICON_BUTTON_SIZE,
  ICON_BUTTON_TYPE
} from '../../global/constants';
import { useMobileDevice } from '../../global/useMobile';
import { Dropdown, DropdownItem } from '../dropdown';
import { RawProjectFile } from '../../mobx/interfaces/project';
import IconButton from '../button/iconButton';
import { FileType } from '../fileUploadCard/styles';
import Tooltip from '../tooltip';

interface Props {
  filesList: RawProjectFile[];
  onClickFile: (item: RawProjectFile) => void;
  onClickRename: () => void;
  OpenModal?: () => void;
  Opendeletemodel?: () => void;
  setSelectedItem: (item: RawProjectFile | null) => void;
  selectedItem: RawProjectFile | null;
}

const FileListView: React.FC<Props> = (props) => {
  const { filesList, onClickFile, onClickRename, OpenModal, Opendeletemodel, setSelectedItem, selectedItem } = props;
  //Other variable
  const isMobile = useMobileDevice();
  const menuItemsWithDownload = [
    { key: FILES_MENU_OPTIONS.VIEW, label: 'View' },
    {
      key: FILES_MENU_OPTIONS.DOWNLOAD,
      label: ' Download'
    },
    { key: FILES_MENU_OPTIONS.RENAME, label: 'Rename' },
    { key: FILES_MENU_OPTIONS.MOVETOFOLDER, label: 'Move to folder' },
    { key: FILES_MENU_OPTIONS.DELETE, label: 'Delete', className: 'red-text' }
  ];
  const menuItems = [
    { key: FILES_MENU_OPTIONS.VIEW, label: 'View' },
    { key: FILES_MENU_OPTIONS.RENAME, label: 'Rename' },
    { key: FILES_MENU_OPTIONS.MOVETOFOLDER, label: 'Move to folder' },
    { key: FILES_MENU_OPTIONS.DELETE, label: 'Delete', className: 'red-text' }
  ];

  const handleMenuClick = (key: number | string, item: RawProjectFile) => {
    key = Number(key);
    if (key === FILES_MENU_OPTIONS.VIEW) {
      onClickFile(item);
    } else if (key === FILES_MENU_OPTIONS.RENAME) {
      if (onClickRename) onClickRename();
    } else if (key === FILES_MENU_OPTIONS.MOVETOFOLDER) {
      if (OpenModal) OpenModal();
    } else if (key === FILES_MENU_OPTIONS.DELETE) {
      if (Opendeletemodel) Opendeletemodel();
    } else if (key === FILES_MENU_OPTIONS.DOWNLOAD) {
      if (item?.url) {
        const link = document.createElement('a');
        link.href = item?.url;
        link.download = item?.name;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  };

  const handleMoreIconClick = (itemId: string) => {
    const foundItem = filesList.find((item) => item.id === itemId);
    if (foundItem) {
      setSelectedItem(foundItem);
    }
  };

  return (
    <Main>
      <Table>
        {!isMobile && (
          <tr>
            <th>Name</th>
            <th>Uploaded on</th>
            <th>Uploaded by</th>
            <th className='last'></th>
          </tr>
        )}

        {filesList?.map((item, index) => {
          const extension = extensionName(item).toLowerCase();
          return (
            <tr
              role='button'
              className={selectedItem?.id === item?.id ? 'active' : ''}
              key={item?.id}
              onClick={() => onClickFile(item)}>
              <td>
                <First>
                  <Icon>
                    {(!item?.uploadFileType || item?.uploadFileType === FILE_TYPES.UPLOAD) &&
                    !FILE_EXTENSIONS.includes(extension) ? (
                      <>
                        <FileIconDiv>
                          <FileSVGIcon name={'blank'} height='28' width='28' viewBox='0 0 60 60' />
                          <FileType fontSize={extension?.length <= 5 ? 5 : 6} className='file-text'>
                            {extension.split('.')?.pop()?.toUpperCase()}
                          </FileType>
                        </FileIconDiv>
                      </>
                    ) : (
                      <FileSVGIcon
                        name={
                          !item?.uploadFileType || item?.uploadFileType === FILE_TYPES.UPLOAD
                            ? extension
                            : `icon_${item?.uploadFileType}`
                        }
                        height='28'
                        width='28'
                        viewBox='0 0 60 60'
                      />
                    )}
                  </Icon>
                  {isMobile ? (
                    <ResponsiveDiv>
                      <DocumentTitle>{item.name}</DocumentTitle>
                      <DocCreated>
                        {calculateDay(item.createdOn)} <span>by</span> {item?.user?.name}
                      </DocCreated>
                    </ResponsiveDiv>
                  ) : (
                    <DocumentTitle>{item.name}</DocumentTitle>
                  )}
                </First>
              </td>
              {!isMobile && (
                <>
                  <td className='second-column'>
                    <Tooltip title={formatDateWithTime(item.createdOn)} maxWidth='max-content'>
                      {calculateDay(item.createdOn)}
                    </Tooltip>
                  </td>
                  <td className='third-column'>{item?.user?.name}</td>
                </>
              )}
              <td className='forth-column'>
                <Dropdown
                  activeClassName={'active-dropdown'}
                  onOutsideClick={() => {
                    setSelectedItem(null);
                  }}
                  content={
                    <IconButton
                      iconName='three-dots-horizontal-icon'
                      size={isMobile ? ICON_BUTTON_SIZE.LARGE : ICON_BUTTON_SIZE.SMALL}
                      variant={ICON_BUTTON_TYPE.TERTIARY}
                      onClick={() => handleMoreIconClick(item?.id)}
                      className={'dropdown-hover'}
                    />
                  }
                  trigger='click'>
                  {(item.uploadFileType === FILE_TYPES.UPLOAD ? menuItemsWithDownload : menuItems).map((menuItem) => (
                    <DropdownItem
                      key={menuItem.key}
                      label={menuItem.label}
                      onClick={() => handleMenuClick(menuItem.key, item)}
                      tone={menuItem.label === 'Delete' ? 'critical' : 'primary'}
                    />
                  ))}
                </Dropdown>
              </td>
            </tr>
          );
        })}
      </Table>
    </Main>
  );
};

export default FileListView;
